import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import {
    Alert,
    Card,
    Dialog,
    DialogHeader,
    DialogFooter,
    DialogBody,
    Input,
    Checkbox,
    List,
    ListItem,
    ListItemSuffix,
    Select,
    Option,
    Button,
    Typography,
    IconButton,
    Tooltip
} from "@material-tailwind/react";

import {
    CheckCircleIcon,
    PlusCircleIcon,
    EllipsisHorizontalCircleIcon,
    FolderMinusIcon,
    ExclamationTriangleIcon,
    XMarkIcon, EnvelopeIcon,
    ChatBubbleLeftIcon,
    BriefcaseIcon,
    SquaresPlusIcon,
    TrashIcon,
    PencilSquareIcon,
} from '@heroicons/react/24/outline';

import * as turf from '@turf/turf';
import { getClients } from './AdminTools';
import { showAlert } from './Alert.jsx';

export default function FertilizationDosesCard(props) {

    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [parameter, setParameter] = useState(props.parameter);
    const [parameters, setParameters] = useState([]);
    const [features, setFeatures] = useState(props.features);
    const [analizy,setAnalizy] = useState(props.analizy || []);

    const [dosesData, setDosesData] = useState({
        parameter: props.parameter,
        friendlyparameter: getFriendlyParam(props.parameter),
        fieldname: props.fieldname,
        ownername: props.clientname,
        fertilizer: "",
        doseunit: "kg/ha",
        doseclass0: "",
        doseclass1: "",
        doseclass2: "",
        doseclass3: "",
        doseclass4: "",
        doseclass5: "",
        doses : [0,0,0,0,0,0]
    });

    const [summary, setSummary] = useState({
        classarea: [0, 0, 0, 0, 0, 0],
        classpercent: [0, 0, 0, 0, 0, 0],
        classfertusage: [0, 0, 0, 0, 0, 0],
        totalarea: 0,
        totalusage: 0,
        usageperha: 0
    });

    React.useEffect(() => {
        dosesData.friendlyparameter = getFriendlyParam(props.parameter);

    }, [analizy]);

    

    React.useEffect(() => {
        console.log('parameter');
        console.log(parameter);
        console.log('props');
        console.log(props);
        dosesData.fieldname = props.fieldfc.features[0].properties.name;

        summary.totalarea = 0;
        features.features.forEach(feature => {
            var area = turf.area(feature);
            var idx = feature.properties[parameter] || 0;
            summary.classarea[idx] += area / 10000.0;
            summary.totalarea += area/10000.0;
        });
        summary.totalusage=0;        
    }, []);


    function getFriendlyParam(param) {
        var friendlyname = param;
        var friendly=analizy.find(an => an.sysname === param);
        if (friendly) friendlyname=friendly.shortname;

        /*
        switch (param) {
            case "Ocena_ph": friendlyname = "Ocena PH"; break;
            case "Ocena_p2o5": friendlyname = "Ocena Fosforu"; break;
            case "Ocena_k2o": friendlyname = "Ocena Potasu"; break;
            case "Ocena_mg": friendlyname = "Ocena Magnezu"; break;
            case "ph_gleby": friendlyname = "Wartość PH"; break;
            case "P2O5": friendlyname = "Fosfor"; break;
            case "K2O": friendlyname = "Potas"; break;
            case "MG": friendlyname = "Magnez"; break;
        }
        */
        return friendlyname;
    }


    function cancelClose() {
        props.close();
    }

    function handleSubmit() {
        delete dosesData.doseclass0;
        delete dosesData.doseclass1;
        delete dosesData.doseclass2;
        delete dosesData.doseclass3;
        delete dosesData.doseclass4;
        delete dosesData.doseclass5;
        console.log(dosesData);
        props.close(dosesData);
    }

    //const handleChange = (e) => {
    function handleChange(e) {
        const { name, value } = e.target;
        setDosesData(prev => ({ ...prev, [name]: value }));
    }

    function handleChangeDose(e) {
        const { name, value } = e.target;
        setDosesData(prev => ({ ...prev, [name]: value }));
        
        /*if (name=="doseclass0") summary.classfertusage[0]=Math.round(Number(value)*summary.classarea[0]);
        if (name=="doseclass1") summary.classfertusage[1]=Math.round(Number(value)*summary.classarea[1]);
        if (name=="doseclass2") summary.classfertusage[2]=Math.round(Number(value)*summary.classarea[2]);
        if (name=="doseclass3") summary.classfertusage[3]=Math.round(Number(value)*summary.classarea[3]);
        if (name=="doseclass4") summary.classfertusage[4]=Math.round(Number(value)*summary.classarea[4]);
        if (name=="doseclass5") summary.classfertusage[5]=Math.round(Number(value)*summary.classarea[5]);
        */
        var index = Number(name.replace("doseclass", ""));
        summary.classfertusage[index] = Math.round(Number(value) * summary.classarea[index]);
        dosesData.doses[index] = Number(value);
        summary.totalusage=0;
        for (var i=0;i<dosesData.doses.length;i++)
        {
            summary.totalusage+=summary.classfertusage[i];
        }
        summary.usageperha=summary.totalusage/summary.totalarea;
        console.log(dosesData);
    }


    function handleDataResponse(data) {

        console.log(data)
        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            //props.close(true);
            setRefreshAfterExit(true);
        }

        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }




    return (
        <div className='absolute w-full h-full top-0 left-0 z-20 items-left justify-left m-auto flex place-content-left bg-black/25'>

            <Card color="white" className="w-full max-w-[24rem] ml-0 my-auto py-4 z-30 max-h-[90vh] overflow-y-auto" shadow={true}>

                <div className="flex items-center justify-between gap-4 w-auto my-2">
                    <Typography color="gray" className="pl-12 font-normal mx-auto">
                        Karta dozowania nawozów
                    </Typography>
                    <IconButton variant='text' className='top-[-1rem] right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>

                </div>
                <form className="mt-2 mx-auto w-full max-w-[20rem] items-center justify-center gap-4 flex flex-col" onSubmit={handleSubmit}>
                    <Input size="md" label="Nazwa klienta" value={dosesData.ownername} name="ownername" type="text" className="shadow-md w-full mx-auto" onChange={handleChange} />
                    <Input size="md" label="Nazwa pola" value={dosesData.fieldname} name="fieldname" type="text" className="shadow-md w-full mx-auto" onChange={handleChange} />
                    <Input size="md" label="Nawożenie na podstawie" value={dosesData.friendlyparameter} name="parameter" type="text" className="shadow-md w-full mx-auto" onChange={handleChange} />
                    <Input size="md" label="Wybrany nawóz" value={dosesData.fertilizer} name="fertilizer" type="text" className="shadow-md w-full mx-auto" onChange={handleChange} />

                    {/*
                    <div className='flex flex-col' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-black/75 text-white p-0.5">
                                <div className='text-[15px] my-0'>Ocena 0</div>
                                <div className='text-[11px] '>brak danych</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass0} name="doseclass0" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[0].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[0]} kg</b></div>
                    </div>
                    */}    


                    <div className='flex flex-col mt-2' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-legend-min text-white p-0.5">
                                <div className='text-[14px] '>Bardzo niska</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass1} name="doseclass1" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[1].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[1]} kg</b></div>
                    </div>



                    <div className='flex flex-col' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-legend-poor text-white p-0.5">
                                <div className='text-[14px] '>Niska</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass2} name="doseclass2" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[2].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[2]} kg</b></div>
                    </div>


                    <div className='flex flex-col' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-legend-med text-black p-0.5">
                                <div className='text-[14px] '>Średnia</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass3} name="doseclass3" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[3].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[3]} kg</b></div>
                    </div>


                    <div className='flex flex-col' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-legend-good text-white p-0.5">
                                <div className='text-[14px] '>Wysoka</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass4} name="doseclass4" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[4].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[4]} kg</b></div>
                    </div>


                    <div className='flex flex-col' >
                        <div className="flex flex-row items-center gap-1">
                            <div className="flex flex-col rounded-md w-[7rem] h-10 items-center text-center justify-center bg-legend-max text-white p-0.5">
                                <div className='text-[14px] '>Bardzo wysoka</div>
                            </div>
                            <div className="flex w-[13rem] h-10 items-center ">
                                <Input size="sm" label="Dawka" value={dosesData.doseclass5} name="doseclass5" type="text" onChange={handleChangeDose} className="shadow-md mx-0" />
                            </div>
                        </div>
                        <div className='text-[11px] text-center'>Powerzchnia obszaru <b>{summary.classarea[5].toFixed(2)} ha</b>, zużycie nawozu <b>{summary.classfertusage[5]} kg</b></div>
                    </div>

                    <div className='text-[14px] text-center'>Szacowane zużycie nawozu <b>{summary.totalusage} kg</b> ({summary.usageperha.toFixed(0)}kg/ha)</div>
                    
                    {/*
                        <div className="flex items-center w-auto my-2">
                            {companies.length > 0 &&
                                <>

                                    <Select label="Spółki zależne" onChange={handleSelectCompany}>
                                        {
                                            companies.map((c) => (
                                                <Option key={c.id} value={c.id.toString()}>{c.name}</Option>
                                            ))
                                        }
                                    </Select>
                                    <Tooltip content="Dodaj spółkę">
                                        <IconButton variant='gradient' size="md" className='p-4 ml-3' color="green" data-refresh={false} onClick={() => handleEditCompany(0)}>
                                            <PlusCircleIcon className='w-5 h-5' />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip content="Edytuj">
                                        <IconButton variant='gradient' size="md" className='p-4 ml-1' color="blue" data-refresh={false} onClick={() => handleEditCompany(company)}>
                                            <PencilSquareIcon className='w-5 h-5' />
                                        </IconButton>
                                    </Tooltip>

                                </>
                            }

                            {companies.length == 0 &&
                                <Button variant='gradient' size="md" className='flex items-center gap-2 px-3 w-auto' color="green" onClick={() => handleEditCompany(0)}>
                                    <BriefcaseIcon className='w-5 h-5' />
                                    Dodaj spółkę
                                </Button>
                            }
                        </div>
                        */}



                    <div className='flex flex-row justify-between w-full mt-4' >
                        <Button className="items-center mx-auto w-40 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 " data-refresh={true} fullWidth type="submit">
                            Zapisz
                        </Button>
                    </div>



                </form>
            </Card>






        </div>
    );
}

